import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import LoadingButton from "@/Shared/LoadingButton";
import CouponForm from "@/Pages/Coupons/Assets/CouponForm";

const Create = () => {
  const {merchants} = usePage().props;
  const {data, setData, errors, post, processing} = useForm({
    code: '',
    description: '',
    link: '',
    restrictions: '',
    start_date: new Date().toISOString(),
    expire_date: new Date().toISOString(),
    source: '',
    ysnTested: 0,
    ysnWorking: 0,
    ysnDeleted: 0,
    internal_notes: '',
    merchant_id: merchants[0][0].merchant_id
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('added.coupons.store').url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('added.coupons')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Added Coupons
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <CouponForm errors={errors} data={data} setData={setData} merchants={merchants}/>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Create Coupon
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Create.layout = page => <Layout title="Create coupon" children={page}/>;
export default Create;
